class Ferramentas {
  static get $inject() {
    return ['$scope', 'UsuariosService']
  }

  constructor($scope, UsuariosService) {
    this.apply = fn => $scope.$apply(fn)
    this.UsuariosService = UsuariosService
  }

  $onChanges({ ferramentasContratadas }) {
    if (ferramentasContratadas && ferramentasContratadas.currentValue) {
      this.ferramentas = this.ferramentasDisponiveis.filter(ferramenta => {
        return !ferramenta.grupo && ferramentasContratadas.currentValue.includes(ferramenta.id)
      })
    }
  }

  openFerramenta(ferramenta) {
    this.onOpen({ ferramenta })
  }
}

angular.module('eficienciaFiscalModule').component('ferramentas', {
  controller: Ferramentas,
  bindings: {
    empresa: '<',
    filiaisCount: '<',
    ferramentasDisponiveis: '<',
    ferramentasContratadas: '<',
    onOpen: '&'
  },
  template: `
  <loading promise="$ctrl.promise" on-retry="$ctrl.loadFerramentas()">
    <div class="row" ng-if="$ctrl.filiaisCount == 0">
      <highlighted class="col-xs-12">
        <main>
          <i class="fa fa-4x fa-exclamation-triangle"></i>
          <br />
          Você não possui acesso a nenhuma filial desta empresa.
        </main>
        <secondary>
          Entre em contato com algum administrador desta empresa para solicitar o acesso.
        </secondary>
      </highlighted>
    </div>

    <div class="row" ng-if="!$ctrl.ferramentas.length && $ctrl.filiaisCount > 0">
      <highlighted class="col-xs-12">
        <main>
          <i class="fa fa-4x fa-exclamation-triangle"></i>
          <br />
          Nenhuma ferramenta liberada para a empresa selecionada.
        </main>
        <secondary>
          Caso seja o administrador desta empresa, entre em contato com nossa equipe comercial para realizar a
          liberação do acesso.
        </secondary>
      </highlighted>
    </div>

    <div class="row" ng-if="$ctrl.ferramentas.length">
      <div class="col-xs-12 margin-bottom-10" ng-if="$ctrl.empresa.consumo.limiteItens">

        <p class="text-danger text-bold" style="font-size: 14px">
          <i class="fa fa-exclamation-triangle"></i>
          O contrato desta empresa está inadimplente. Seu acesso será bloqueado em
          <ng-pluralize count="$ctrl.empresa.contrato.diasAcessoRestantes"
            when="{'one': '1 dia.', 'other': '{} dias.'}">
          </ng-pluralize>
        </p>

      </div>

      <div class="col-xs-12 smart-form">
        <section>
          <label>
            Filtrar <i ng-click="$ctrl.filtro = ''" ng-if="$ctrl.filtro"
              class="fa fa-trash-o text-danger cursor-pointer"></i>
          </label>
          <label class="input">
            <input type="text" ng-model="$ctrl.filtro" placeholder="Digite o título da ferramenta para pesquisar" />
          </label>
        </section>
      </div>

      <div ng-if="ferramenta.descricao" ng-repeat="ferramenta in filtered = ($ctrl.ferramentas | filter: $ctrl.filtro)"
        class="col-xs-12 tooltip-300 list-ferramentas">
        <div class="panel panel-info pricing-big no-margin transition-3">
          <div ng-click="$ctrl.openFerramenta(ferramenta)" class="panel-heading cursor-pointer clearfix">
            <h3 class="panel-title-dashbord">{{ferramenta.nome}}</h3>
            <button class="btn btn-block btn-primary">Acessar</button>
          </div>
          <div class="panel-body cursor-pointer">
            <span class="panel-text">{{ferramenta.descricao}}</span>
          </div>
        </div>
      </div>

      <div ng-if="!filtered.length" class="col-xs-12">
        <highlighted>
          <main>Nenhuma ferramenta localizada para o filtro utilizado.</main>
        </highlighted>
      </div>
    </div>
  </loading>
  `
})

export default Ferramentas
